import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const RedStripe: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--redstripe')}
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <line className={s.redStripe} x1="-20%" y1="100%" x2="40%" y2="-10%" />
  </svg>
);

export default RedStripe;
